// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_tech_discovery_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `He returned to Switzerland and spent years engineering a sole that recreates that sensation anywhere — a pocket of air that turns any hard surface into soft ground.`
};

const el_tech_discovery_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `Επέστρεψε στην Ελβετία και αφιέρωσε χρόνια στη μηχανική σχεδίαση μιας σόλας που αναπαράγει αυτή την αίσθηση οπουδήποτε — ένας θύλακας αέρα που μετατρέπει κάθε σκληρή επιφάνεια σε μαλακό έδαφος.`
};

const ru_tech_discovery_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `Он вернулся в Швейцарию и годами разрабатывал подошву, воссоздающую это ощущение на любой поверхности — воздушную подушку, превращающую твёрдый пол в мягкий грунт.`
};

const he_tech_discovery_body2 = /** @type {(inputs: {}) => string} */ () => {
	return `הוא חזר לשוויץ והשקיע שנים בפיתוח סוליה שמשחזרת את התחושה בכל מקום — כיס אוויר שהופך כל משטח קשה לקרקע רכה.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const tech_discovery_body2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.tech_discovery_body2(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("tech_discovery_body2", locale)
	if (locale === "en") return en_tech_discovery_body2(inputs)
	if (locale === "el") return el_tech_discovery_body2(inputs)
	if (locale === "ru") return ru_tech_discovery_body2(inputs)
	if (locale === "he") return he_tech_discovery_body2(inputs)
	return "tech_discovery_body2"
};